import {
  Button,
  Drawer,
  Form,
  Input,
  List,
  Modal,
  Select,
  Skeleton,
  Space,
} from "antd";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { DeleteOutlined } from "@ant-design/icons";
import { NotificationInfo } from "../../../../../../context";

const CostPerProduct = ({ open, close, selectedData }) => {
  const { rerunNotif } = useContext(NotificationInfo);
  const [initLoading, setInitLoading] = useState(true);
  const [addCostPerProd, setAddCostPerProd] = useState(false);
  const [merchantCostPerProduct, setMerchantCostPerProduct] = useState({
    data: [],
    ready: false,
  });
  const [tableData, setTableData] = useState(null);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedMethod, setSelectedMethod] = useState(null);

  const getAllMerchantsCostPerProduct = () => {
    var params = { merchant_id: selectedData.user_id };
    axios
      .get("user/admin/get/cost-per-product", { params })
      .then((response) => {
        const data = response.data;
        setMerchantCostPerProduct({ data, ready: true });
        setInitLoading(false);
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  };

  useEffect(() => {
    getAllMerchantsCostPerProduct();
  }, [selectedData]);

  const handleOk = () => {
    setConfirmLoading(true);
    setTimeout(() => {
      setOpenDelete(false);
      setConfirmLoading(false);
      handleRemoveCostProduct();
    }, 2000);
  };

  const handleRemoveCostProduct = () => {
    const formdata = new FormData();
    formdata.append("id", tableData.id);
    setInitLoading(true);
    axios
      .post("user/admin/remove/cost-per-product", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Removed cost product successfully.");
          setTimeout(() => {
            getAllMerchantsCostPerProduct();
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  };

  const handleCreateCostPerTranx = (values) => {
    const formdata = new FormData();
    formdata.append("merchant_id", selectedData.user_id);

    for (const name in values) {
      formdata.append(name, values[name]);
    }
    setIsSubmitting(true);
    axios
      .post("user/admin/create/new-cost-per-product", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          setAddCostPerProd(false);
          rerunNotif("success", "Created cost per product successfully.");
          setTimeout(() => {
            setSelectedMethod(null);
            setIsSubmitting(false);
            getAllMerchantsCostPerProduct();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  return (
    <Drawer
      title="Product Config"
      width={window.innerWidth > 500 ? 500 : window.innerWidth}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
      extra={
        <Space>
          <Button
            type="primary"
            onClick={() => {
              setAddCostPerProd(true);
            }}
            disabled={
              merchantCostPerProduct.ready &&
              merchantCostPerProduct.data.length > 0
            }
          >
            Add
          </Button>
        </Space>
      }
    >
      <List
        className="demo-loadmore-list"
        loading={initLoading}
        itemLayout="horizontal"
        dataSource={merchantCostPerProduct.data}
        renderItem={(item, index) => (
          <List.Item
            actions={[
              <DeleteOutlined
                style={{ cursor: "pointer", color: "red", fontSize: 18 }}
                onClick={() => {
                  setTableData(item);
                  setOpenDelete(true);
                }}
              />,
            ]}
          >
            <Skeleton avatar title={false} loading={item.loading} active>
              <List.Item.Meta
                title={`${item.description}`}
                description={
                  parseFloat(item.is_percentage) === 1
                    ? `${item.percentage}%`
                    : `₱ ${parseFloat(item.amount).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                      `
                }
              />
            </Skeleton>
          </List.Item>
        )}
      />

      <Modal
        title=""
        open={addCostPerProd}
        onCancel={() => setAddCostPerProd(false)}
        footer={null}
        width={350}
        centered
      >
        <Form
          layout="vertical"
          name="create-per-product"
          onFinish={handleCreateCostPerTranx}
          autoComplete="off"
        >
          <Space direction="vertical" style={{ width: "100%", margin: 0 }}>
            <Form.Item
              name="description"
              label="Description"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <Input placeholder="Set description" size="large" />
            </Form.Item>

            <Form.Item
              name="is_percentage"
              label="Is Percentage?"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <Select
                size="large"
                showSearch
                onChange={(e) => setSelectedMethod(e)}
              >
                <Select.Option value={0}>No</Select.Option>
                <Select.Option value={1}>Yes</Select.Option>
              </Select>
            </Form.Item>

            {parseInt(selectedMethod) === 1 && (
              <Form.Item
                name="percentage"
                label="Percentage"
                rules={[
                  {
                    required: true,
                    message: "Required",
                  },
                ]}
              >
                <Input placeholder="Set percentage 1 - 100" size="large" />
              </Form.Item>
            )}

            {parseInt(selectedMethod) === 0 && (
              <Form.Item
                name="amount"
                label="Amount"
                rules={[
                  {
                    required: true,
                    message: "Required",
                  },
                ]}
              >
                <Input placeholder="Set amount" size="large" />
              </Form.Item>
            )}
          </Space>

          <Form.Item style={{ marginTop: "20px" }}>
            <Button
              type="primary"
              loading={isSubmitting}
              htmlType="submit"
              style={{ width: "100%", borderRadius: "20px" }}
            >
              {isSubmitting ? "Loading" : "Save"}
            </Button>
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title="Are you sure to delete this cost?"
        open={openDelete}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={() => setOpenDelete(false)}
        centered
        width={350}
      />
    </Drawer>
  );
};

export default CostPerProduct;
